const SELF_PROFILE_ROUTE_NAMES = new Set([
  'employee-detail',
  'employee-edit',
  'plan-editor',
  'appraisal-editor',
  'employee-profile-report'
]);

/**
 * True when the current route is an employee shell view for the signed-in user.
 * `/my-profile` renders the same shell view — sidebar treats self employee routes as My Profile.
 */
export function isSelfEmployeeShellRoute(activeRouteName, routeParams, currentUserId) {
  if (currentUserId == null || activeRouteName == null) return false;
  if (!SELF_PROFILE_ROUTE_NAMES.has(String(activeRouteName))) return false;
  const routeUserId = routeParams?.id;
  if (routeUserId == null) return false;
  return String(routeUserId) === String(currentUserId);
}

/**
 * Match route path against nav item path (exact or nested child).
 * When routeName + activeRouteName are provided, name match wins (avoids /employees vs /employees/:id).
 * @param {string|undefined|null} path
 * @param {string} currentPath
 * @param {{
 *   routeName?: string,
 *   activeRouteName?: string|symbol|null,
 *   relatedRouteNames?: string[],
 *   routeParams?: Record<string, unknown>,
 *   currentUserId?: string|number|null,
 *   navKey?: string
 * }} [options]
 */
export function isRouteActive(path, currentPath, options = {}) {
  const {
    routeName,
    activeRouteName,
    relatedRouteNames,
    routeParams,
    currentUserId,
    navKey
  } = options;

  const selfProfile = isSelfEmployeeShellRoute(activeRouteName, routeParams, currentUserId);
  const queryTab = Array.isArray(options.queryTab) ? options.queryTab[0] : options.queryTab;
  const onOwnRequirements = String(queryTab || '') === 'job-description'
    && (activeRouteName === 'my-profile' || selfProfile);

  if (navKey === 'job-descriptions' && onOwnRequirements) return true;

  if (navKey === 'my-profile') {
    if (onOwnRequirements) return false;
    if (activeRouteName === 'my-profile' || selfProfile) return true;
    return false;
  }

  if (navKey === 'table' && selfProfile) {
    return false;
  }

  if (activeRouteName) {
    if (routeName && routeName === activeRouteName) return true;
    if (Array.isArray(relatedRouteNames) && relatedRouteNames.includes(activeRouteName)) {
      return true;
    }
    // Named shell tab — avoid path-prefix false positives on unrelated routes.
    if (routeName) return false;
  }
  if (!path || !currentPath) return false;
  return currentPath === path || currentPath.startsWith(`${path}/`);
}
